import React from 'react';

import ReactDOM from 'react-dom/client';

import { CssBaseline } from '@mui/material';

import ThemeProvider from '@common/providers/Theme';
import GlobalContextProvider from '@hooks/Context/GlobalContext';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <GlobalContextProvider>
    <ThemeProvider>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </GlobalContextProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
